// Navigation
const NavigationBar = () => import('@/components/NavigationBar')

// Views
const LoginView = () => import('@/views/LoginView')
const ProfileOnboardingView = () => import('@/views/ProfileOnboardingView')
const SettingsView = () => import('@/views/SettingsView')
const DeleteAccountView = () => import('@/views/DeleteAccountView')

import { logOut } from '../auth'

const commonRoutes = [
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView,
    props: true,
    meta: { guestOnly: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '/onboarding',
    name: 'ProfileOnboardingView',
    component: ProfileOnboardingView,
    props: true,
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '/settings',
    name: 'SettingsView',
    components: {
      default: SettingsView,
      navigation: NavigationBar
    },
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '/delete-account',
    name: 'DeleteAccountView',
    components: {
      default: DeleteAccountView,
      navigation: NavigationBar
    },
    props: { navigation: { back: true } },
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '/sign-out',
    name: 'SignOut',
    beforeEnter: (to, from, next) => {
      logOut()
      next('/')
    },
    meta: { requiresAuth: true, sitemap: { ignoreRoute: true } }
  },
  {
    path: '*',
    beforeEnter: (to, from, next) => next('/')
  }
]

export default commonRoutes
